export var isSeparator = function isSeparator(item) {
  return Object.prototype.hasOwnProperty.call(item, 'separator');
};
export var isGroup = function isGroup(item) {
  return Object.prototype.hasOwnProperty.call(item, 'items');
};
export var isApp = function isApp(item) {
  return !isGroup(item) && !isSeparator(item);
};